const routes = [{
  path: '/feiche/tuan',
  component: () => import('@/views/feiche/tuan/order'),
  name: 'feiche-tuan',
  meta: {
    title: '团险订单'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/feiche/tuan.js